module.exports = __webpack_public_path__ + "static/media/about-18.1706c024.webp";